import VueApexCharts from "vue3-apexcharts";
import vClickOutside from "click-outside-vue3";
import { registerScrollSpy } from 'vue3-scroll-spy';
import Maska from 'maska';
import Notifications from '@kyvg/vue3-notification';
import BootstrapVueNext from 'bootstrap-vue-next';

export default (app) => {
    app.use(VueApexCharts)
        .use(vClickOutside)
        .use(registerScrollSpy)
        .use(Maska)
        .use(Notifications)
        .use(BootstrapVueNext);
};
